/* eslint react/prop-types: 0 */
/* global $ */
/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './TelemedicinaPageUserLoggedIn.css';
import ValidacionesTecnicas from '../../components/Telemedicina/ValidacionesTecnicas/ValidacionesTecnicas';
import TurnosSolicitud from '../../components/Telemedicina/TurnosSolicitud/TurnosSolicitud';
import ModalFinalizado from '../../components/Telemedicina/ModalFinalizado/ModalFinalizado';
import ModalCuandoUtilizarEconsulta from '../../components/Telemedicina/ModalCuandoUtilizarEconsulta/ModalCuandoUtilizarEconsulta';
import ModalError from '../../components/Telemedicina/ModalError/ModalError';
import NavegadorIncompatible from '../../components/Telemedicina/NavegadorIncompatible/NavegadorIncompatible';
import ErrorConexionVideoLlamada from './ErrorConexionVideoLlamada/ErrorConexionVideoLlamada';
import MuyProntoParaIniciarConsulta from '../../components/Telemedicina/MuyProntoParaIniciarConsulta/MuyProntoParaIniciarConsulta';
//import MonitoringUtil from '../../utils/monitoringUtil.js';
import {
  LOGIN_STATUS_LOGGED_IN,
} from '../../constants';


import {
  Tabs,
  Tab,
  TabPanel,
  TabList,
  TabContent,
} from '../../components/Tabs';


class TelemedicinaPageUserLoggedIn extends React.Component {

  constructor(){
    super();
    this.state = {
      connectionError: false
    }
  }

  componentWillMount(){
    //Registro en el sistema de Monitoreo si es que no existe
    //const monitoringUtil = new MonitoringUtil();
    //monitoringUtil.createAffilliate();
    //monitoringUtil.createAffilliateLog({ interaction:"E-Consulta", message:"Pantalla Inicial Tabs E-Consulta" });  
  }

  static showModalBienvenida() {
    if ( window.location !== window.parent.location ) {
      window.top.postMessage(JSON.stringify({ type: 'MODAL_WHEN_USE' }), '*');
    }else{
      $('#ModalCuandoUtilizarEconsulta').modal('show');
    }
  }

  render() {
    var isOpera = typeof window.opr !== "undefined";
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !isOpera && !isSafari;
    //var isChrome = true;
    if(!isChrome){
      return (
        <NavegadorIncompatible>
          Estas utilizando un navegador web que no es compatible.
          <br/>Para mejorar tu experiencia recomendamos el uso de Google
          Chrome.
        </NavegadorIncompatible>
      )
    }else{
      //const isNotCompatibleChromeVersion = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2] <= 51;
      const isNotCompatibleChromeVersion = false;
      if(isNotCompatibleChromeVersion){
        return (
          <NavegadorIncompatible>
            Tu versión de Chrome no es compatible. Para mejorar tu experiencia te recomendamos actualizar el navegador.
          </NavegadorIncompatible>
        )
      }
      return (
        <div className={s.mtMinus}>
          <ModalFinalizado/>
          <ModalCuandoUtilizarEconsulta />

          {this.props.errorServicio ? <ModalError msg={this.props.errorServicio}/> : ''}

          <div className={`${s.root}`}>
            <div className={`${s.container} row`}>
              <div className="col-md-12">
                {this.props.validaciones_tecnicas
                  ? <ValidacionesTecnicas
                      //origen="espontaneo"
                      // origen={this.props.origen}
                      // especialidad={$('#especialidad').val()}
                    />
                  : this.props.show
                    ? <MuyProntoParaIniciarConsulta
                      fecha={this.props.fecha}
                     /> :
                     <div className="col-md-12">
                          <p
                            role="presentation"
                            className={s.linkModalBienvenida}
                            onClick={() =>
                              TelemedicinaPageUserLoggedIn.showModalBienvenida()}
                          >
                            ¿Cuándo utilizar E-Consulta?
                          </p>

                        <div>
                        <Tabs>
                            {/* <TabList> */}
                              {/* <div to="/telemedicina/solicitud-turnos" active={this.props.activeSolicitud}> */}
                              <div to="/telemedicina/solicitud-turnos" active={this.props.activeSolicitud}>
                              {/* Solicitud de turnos */}
                              </div>
                              {/* <Tab to="/telemedicina/consulta-turnos" active={this.props.consultaTurnos}>
                                Consulta de Turnos
                              </Tab>
                              <Tab to="/telemedicina/mis-recetas" active={this.props.activeRecetas}>
                                Mis Recetas
                              </Tab> */}
                              {/* </TabList> */}
                            <TabPanel>
                              <TabContent active>
                                <this.props.component/>
                              </TabContent>
                            </TabPanel>
                          </Tabs>
                          </div>  
                        </div> 
                        }
              </div>
            </div>
          </div>
        </div>
      );
      
    }
  }
}

const mapStateToProps = state => ({
  validaciones_tecnicas: state.telemedicina.validaciones_tecnicas,
  errorServicio: state.telemedicina.error_servicio,
  show: state.telemedicina.muyProntoParaIniciarConsulta.show,
  fecha: state.telemedicina.muyProntoParaIniciarConsulta.fecha,
});

export default connect(mapStateToProps, null)(
  withStyles(s)(TelemedicinaPageUserLoggedIn),
);



// WEBPACK FOOTER //
// ./src/routes/telemedicina/TelemedicinaPageUserLoggedIn.js